import React, { Component } from 'react'
import i18n from 'live/services/i18n'
import AdminHeader from 'live/components/header/ui/admin/header'
import CodeMirror from 'live/components/codemirror/codemirror'
import globalNotification from 'live/services/global-notification'

import { fetchAllConfigFiles, saveAllConfigFiles } from '../api'
import { FormEnabledContext } from 'live/context/form-enabled'

class ConfigForm extends Component {
    static contextType = FormEnabledContext
    constructor(props: Props) {
        super(props)
        this.csdsFileTextElement = null
        this.activitiesFileTextElement = null
        this.csdActivitiesAssociationTextElement = null
        this.interventionsFileTextElement = null
        this.initiativesFileTextElement = null
        this.clientRolesFileTextElement = null
        this.detailing1FileTextElement = null
        this.detailing2FileTextElement = null
        this.detailingAssociationTextElement = null
        this.serviceNatureFileTextElement = null
        this.smsGainFileTextElement = null
        this.performaceGainFileTextElement = null
        this.state = {
            saving: false,
            saved: false,
            showErrors: false,
            loading: true,
            csdsFile: '',
            activitiesFile: '',
            csdActivitiesAssociationFile: '',
            interventionsFile: '',
            initiativesFile: '',
            clientRolesFile: '',
            detailing1File: '',
            detailing2File: '',
            detailingAssociationFile: '',
            serviceNatureFile: '',
            smsGainFile: '',
            performanceGainFile: ''
        }
    }

    componentDidUpdate() {}

    componentDidMount() {
        fetchAllConfigFiles().then(results => {
            this.setState({
                csdsFile: JSON.stringify(results.csdsFile, null, 1),
                activitiesFile: JSON.stringify(results.activitiesFile, null, 1),
                csdActivitiesAssociationFile: JSON.stringify(results.csdActivitiesAssociationFile, null, 1),
                interventionsFile: JSON.stringify(results.interventionsFile, null, 1),
                initiativesFile: JSON.stringify(results.initiativesFile, null, 1),
                clientRolesFile: JSON.stringify(results.clientRolesFile, null, 1),
                detailing1File: JSON.stringify(results.detailing1File, null, 1),
                detailing2File: JSON.stringify(results.detailing2File, null, 1),
                detailingAssociationFile: JSON.stringify(results.detailingAssociationFile, null, 1),
                serviceNatureFile: JSON.stringify(results.serviceNatureFile, null, 1),
                smsGainFile: JSON.stringify(results.smsGainFile, null, 1),
                performanceGainFile: JSON.stringify(results.performanceGainFile, null, 1),
                loading: false
            })
        })
    }

    onFileCodeChange = (newCode, fileField) => {
        this.setState({
            [fileField]: newCode,
            showErrors: !this.hasError(),
            saved: false
        })
    }

    hasError = () => {
        return (
            !this.csdsFileTextElement.hasError() &&
            !this.activitiesFileTextElement.hasError() &&
            !this.csdActivitiesAssociationTextElement.hasError() &&
            !this.interventionsFileTextElement.hasError() &&
            !this.initiativesFileTextElement.hasError() &&
            !this.clientRolesFileTextElement.hasError() &&
            !this.detailing1FileTextElement.hasError() &&
            !this.detailing2FileTextElement.hasError() &&
            !this.detailingAssociationTextElement.hasError() &&
            !this.serviceNatureFileTextElement.hasError() &&
            !this.smsGainFileTextElement.hasError() &&
            !this.performaceGainFileTextElement.hasError()
        )
    }

    saveAllConfigFiles = (
        csdFile,
        activitiesFile,
        csdActivitiesFile,
        interventionsFile,
        initiativesFile,
        clientRolesFile,
        detailing1File,
        detailing2File,
        detailingAssociationFile,
        serviceNatureFile,
        smsGainFile,
        performanceGainFile
    ) => {
        this.setState({
            saving: true,
            saved: false
        })

        saveAllConfigFiles(
            csdFile,
            activitiesFile,
            csdActivitiesFile,
            interventionsFile,
            initiativesFile,
            clientRolesFile,
            detailing1File,
            detailing2File,
            detailingAssociationFile,
            serviceNatureFile,
            smsGainFile,
            performanceGainFile
        )
            .then(results => {
                this.setState({
                    saving: false,
                    saved: true
                })
            })
            .catch(r => {
                globalNotification.error(
                    `${i18n('Houve erro ao salvar as configurações dos Registros de Atividade.')}  ${
                        r.statusText ? `- (${r.statusText})` : ''
                    }`
                )
                this.setState({
                    saving: false,
                    saved: false
                })
            })
    }

    onSave = () => {
        this.saveAllConfigFiles(
            JSON.parse(this.state.csdsFile),
            JSON.parse(this.state.activitiesFile),
            JSON.parse(this.state.csdActivitiesAssociationFile),
            JSON.parse(this.state.interventionsFile),
            JSON.parse(this.state.initiativesFile),
            JSON.parse(this.state.clientRolesFile),
            JSON.parse(this.state.detailing1File),
            JSON.parse(this.state.detailing2File),
            JSON.parse(this.state.detailingAssociationFile),
            JSON.parse(this.state.serviceNatureFile),
            JSON.parse(this.state.smsGainFile),
            JSON.parse(this.state.performanceGainFile)
        )
    }

    render() {
        let {
            csdsFile,
            activitiesFile,
            csdActivitiesAssociationFile,
            interventionsFile,
            initiativesFile,
            clientRolesFile,
            detailing1File,
            detailing2File,
            detailingAssociationFile,
            serviceNatureFile,
            smsGainFile,
            performanceGainFile,
            showErrors,
            saving,
            saved,
            loading
        } = this.state

        let btnCls = 'btn btn-primary'

        if (saving || saved || showErrors) btnCls += ' disabled'

        if (saved) btnCls += ' btn-success'

        const { readonly } = this.context

        return (
            <div className={'admin-content ' + (loading ? 'loading' : '')}>
                <div className="admin-inner activitylog-config">
                    <AdminHeader>
                        <h2>
                            <span>Registros de Atividades</span>
                        </h2>
                        <div className="activitylog-warning-msg">
                            <span>
                                Alterar/Apagar os campos 'id' nas listas compromete o correto funcionamento dos
                                registros de atividade. Campos 'id' devem ser únicos em cada lista.
                            </span>
                        </div>
                    </AdminHeader>

                    <div className="activitylog-body">
                        <div className="form-area">
                            <label>{'CSDs'}</label>
                            <TextJsonArea
                                code={csdsFile}
                                ref={element => (this.csdsFileTextElement = element)}
                                onChange={newCode => this.onFileCodeChange(newCode, 'csdsFile')}
                            />
                        </div>
                        <div className="form-area">
                            <label>{'Atividades'}</label>
                            <TextJsonArea
                                code={activitiesFile}
                                ref={element => (this.activitiesFileTextElement = element)}
                                onChange={newCode => this.onFileCodeChange(newCode, 'activitiesFile')}
                            />
                        </div>
                        <div className="form-area">
                            <label>{'Associação de CSDs e Actividades'}</label>
                            <TextJsonArea
                                code={csdActivitiesAssociationFile}
                                ref={element => (this.csdActivitiesAssociationTextElement = element)}
                                onChange={newCode => this.onFileCodeChange(newCode, 'csdActivitiesAssociationFile')}
                            />
                        </div>
                        <div className="form-area">
                            <label>{'Intervenções'}</label>
                            <TextJsonArea
                                code={interventionsFile}
                                ref={element => (this.interventionsFileTextElement = element)}
                                onChange={newCode => this.onFileCodeChange(newCode, 'interventionsFile')}
                            />
                        </div>
                        <div className="form-area">
                            <label>{'Iniciativas'}</label>
                            <TextJsonArea
                                code={initiativesFile}
                                ref={element => (this.initiativesFileTextElement = element)}
                                onChange={newCode => this.onFileCodeChange(newCode, 'initiativesFile')}
                            />
                        </div>
                        <div className="form-area">
                            <label>{'Função do Cliente'}</label>
                            <TextJsonArea
                                code={clientRolesFile}
                                ref={element => (this.clientRolesFileTextElement = element)}
                                onChange={newCode => this.onFileCodeChange(newCode, 'clientRolesFile')}
                            />
                        </div>
                        <div className="form-area">
                            <label>{'Detalhamento 1'}</label>
                            <TextJsonArea
                                code={detailing1File}
                                ref={element => (this.detailing1FileTextElement = element)}
                                onChange={newCode => this.onFileCodeChange(newCode, 'detailing1File')}
                            />
                        </div>
                        <div className="form-area">
                            <label>{'Detalhamento 2'}</label>
                            <TextJsonArea
                                code={detailing2File}
                                ref={element => (this.detailing2FileTextElement = element)}
                                onChange={newCode => this.onFileCodeChange(newCode, 'detailing2File')}
                            />
                        </div>
                        <div className="form-area">
                            <label>{'Associação do Detalhamento'}</label>
                            <TextJsonArea
                                code={detailingAssociationFile}
                                ref={element => (this.detailingAssociationTextElement = element)}
                                onChange={newCode => this.onFileCodeChange(newCode, 'detailingAssociationFile')}
                            />
                        </div>
                        <div className="form-area">
                            <label>{i18n('Service Nature')}:</label>
                            <TextJsonArea
                                code={serviceNatureFile}
                                ref={element => (this.serviceNatureFileTextElement = element)}
                                onChange={newCode => this.onFileCodeChange(newCode, 'serviceNatureFile')}
                            />
                        </div>
                        <div className="form-area">
                            <label>{'Ganho em Sms'}</label>
                            <TextJsonArea
                                code={smsGainFile}
                                ref={element => (this.smsGainFileTextElement = element)}
                                onChange={newCode => this.onFileCodeChange(newCode, 'smsGainFile')}
                            />
                        </div>
                        <div className="form-area">
                            <label>{'Ganho em Performance'}</label>
                            <TextJsonArea
                                code={performanceGainFile}
                                ref={element => (this.performaceGainFileTextElement = element)}
                                onChange={newCode => this.onFileCodeChange(newCode, 'performanceGainFile')}
                            />
                        </div>
                    </div>
                    <div className="activitylog-footer">
                        <button className={btnCls} onClick={this.onSave} disabled={readonly}>
                            {saving && !saved ? (
                                <span>
                                    <i className="fa fa-spinner fa-spin" /> Saving
                                </span>
                            ) : null}
                            {!saving && saved ? (
                                <span>
                                    <i className="fa fa-check" /> Saved
                                </span>
                            ) : null}
                            {!saving && !saved ? <span>Save</span> : null}
                        </button>
                        <span>
                            or <a href="/admin">Cancel</a>
                        </span>
                    </div>
                </div>
            </div>
        )
    }
}

export default ConfigForm

class TextJsonArea extends Component {
    constructor(props: Props) {
        super(props)
        this.state = {
            code: '',
            errorParsing: false
        }
        this.updateCode = this.updateCode.bind(this)
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            code: nextProps.code
        })
    }

    updateCode(newCode) {
        let errorParsing = false

        try {
            let parsedCode = JSON.parse(newCode)
        } catch (e) {
            errorParsing = true
        }
        this.setState({
            code: newCode,
            errorParsing: errorParsing
        })
        if (this.props.onChange) this.props.onChange(newCode)
    }

    hasError = () => {
        return this.state.errorParsing
    }

    render() {
        let { errorParsing, code } = this.state

        return (
            <div className="file-editor-area">
                <CodeMirror
                    className={'text-area ' + (errorParsing ? 'error-editing' : '')}
                    value={code}
                    onChange={this.updateCode}
                    options={{
                        lineNumbers: true,
                        lineWrapping: true,
                        mode: 'application/ld+json'
                    }}
                />
            </div>
        )
    }
}
